'use client';

import { useIntl } from 'react-intl';
import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import type { CustomerRatingsOverviewProps } from '../CustomerRatingsOverview/CustomerRatingsOverview';
import { CustomerRatingsOverview } from '../CustomerRatingsOverview/CustomerRatingsOverview';
import { customerRatingsOverviewCardMessages } from './CustomerRatingsOverviewCard.messages';

export type CustomerRatingsOverviewCardProps = Pick<CustomerRatingsOverviewProps, 'data'>;

/**
 * The CustomerRatingsOverviewCard component displays the ratings overview in a card
 */
export const CustomerRatingsOverviewCard = ({ data }: CustomerRatingsOverviewCardProps) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <Card>
        <CardHeader hasDivider>
          {formatMessage(customerRatingsOverviewCardMessages.header)}
        </CardHeader>
        <CardContent className="py-2">
          <CustomerRatingsOverview data={data} />
        </CardContent>
      </Card>
    </div>
  );
};
